
import { useState } from "react";

import Score from "./Score";
import History from "./History";
import Choice from "./Choice";
import getBot from "./Bots";

function getScore(player, bot) {
  if (player && bot)
    return [3, 3];
  else if (!player && bot)
    return [5, 0];
  else if (player && !bot)
    return [0, 5];
  else
    return [1, 1];
}

function Button({ label, color, handleClick }) {
  return (
    <div className='col-auto'>
      <button className={`btn btn-lg btn-outline-${color}`}onClick={handleClick}>{label}</button>
    </div>
  );
}

function Buttons({ handler, restart }) {
  return (
    <div className='container row mb-3 justify-content-center'>
      <Button label='Cooperate' color='success' handleClick={() => handler(true)} />
      <Button label='Defect' color='danger' handleClick={() => handler(false)} />
      <Button label='Restart' color='primary' handleClick={restart} />
    </div>
  );
}

function Game() {
  let [score, setScore] = useState([0, 0]);
  let [history, setHistory] = useState([]);
  let [bot, setBot] = useState(getBot());

  let handleClick = (choice) => {
    let botChoice = bot.choose(history);
    history.push([choice, botChoice])
    history = history.slice(-4);
    setHistory(history);
    let res = getScore(choice, botChoice);
    setScore([score[0] + res[0], score[1] + res[1]]);
  };

  let restart = () => {
    setBot(getBot());
    setHistory([]);
    setScore([0, 0]);
  };

  return (
    <div className='container'>
      <div className='row m-3 justify-content-center'>
        <History history={history.slice(-4, -1)} />
        <Choice choices={history[history.length - 1]} bot={bot} />
        <Score player={score[0]} bot={score[1]} />
      </div>
      <div className='row mt-5 justify-content-center'>
        <Buttons handler={handleClick} restart={restart} />
      </div>
    </div>
  );
}

export default Game;
